import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    Button,
    InputLabel,
    CardMedia,
    useMediaQuery,
} from '@mui/material';
import { useAppDispatch } from 'store/hooks';
import { getMCATScore, getWellbeingScore } from 'store/slices/mcatSlice';
import { useNavigate } from 'react-router';
import { ROUTE } from 'route/RouteEnums';
import COLORS from 'theme/colors';

const MWiseWellnessTracker = (props: any) => {
    const [wellnessScore, setWellnessScore] = useState<number>();
    const [wellnessCategory, setWellnessCategory] = useState<string>();
    const [iWiseScore, setIWiseScore] = useState<number>();
    const [iWiseCategory, setIWiseCategory] = useState<string>();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isSm = useMediaQuery('(max-width:900px)');

    const categorize = (score: number, type: 'wellness' | 'iwise'): string => {
        if (score === null || score === undefined) return 'NA';
        const thresholds =
            type === 'iwise'
                ? [50, 100, 225, 325, 400, 450, 500]
                : [100, 200, 500, 600, 800, 900, 1000];
        const labels = [
            'In Crisis',
            'Critical',
            'Struggling',
            'Vulnerable',
            'Balanced',
            'Stable',
            'Thriving',
        ];
        const idx = thresholds.findIndex((limit) => score < limit);
        return labels[idx >= 0 ? idx : labels.length - 1];
    };

    useEffect(() => {
        dispatch(getWellbeingScore(props.patientId))
            .unwrap()
            .then((res: any) => {
                if (res.status === 200) {
                    const score = res.data.wellnessScore;
                    setWellnessScore(score);
                    setWellnessCategory(categorize(score, 'wellness'));
                }
            });

        dispatch(getMCATScore(props.patientId))
            .unwrap()
            .then((res: any) => {
                if (res.status === 200) {
                    const score = res.data.mcatIScore;
                    setIWiseScore(score);
                    setIWiseCategory(categorize(score, 'iwise'));
                }
            });
    }, [props?.patientId, dispatch]);

    const ScoreCard = ({
        label,
        score,
        category,
        imageSrc,
        onClick,
    }: {
        label: string;
        score: number | undefined;
        category: string | undefined;
        imageSrc: string;
        onClick: () => void;
    }) => (
        <Grid item xs={12} md={6} >
            <InputLabel>{label}</InputLabel>
            <Box
                sx={{
                    border: '1px solid #FFC44D',
                    borderRadius: '12px',
                    p: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: 160,
                    backgroundColor: '#FFF',
                }}
            >
                {/* Left content: Score and Status */}
                {/* Left content: Score and Status */}
                <Box sx={{ flex: 1 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={6}>
                            <Typography>Score</Typography>
                            <Typography sx={{ fontWeight: 700, mt: '5px', lineHeight: 1 }}>
                                {score ?? 'NA'}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-start"
                        >
                            <Typography>Status</Typography>
                            <Typography sx={{ mt: '5px', lineHeight: 1 }}>
                                {category ?? 'NA'}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* Hide Explore Details if both are NA */}
                    {!(score === undefined || score === null) ||
                        !(category === undefined || category === null || category === 'NA') ? (
                        <Button
                            variant="text"
                            sx={{
                                fontSize: '14px',
                                mt: '10px',
                                p: 0,
                                color: COLORS.Link,
                                textAlign: 'left',
                            }}
                            onClick={onClick}
                        >
                            Explore Details
                        </Button>
                    ) : null}
                </Box>
                {/* Right image */}
                <CardMedia
                    component="img"
                    src={imageSrc}
                    alt={`${label} graphic`}
                    sx={{
                        width: 110,
                        height: 110,
                        ml: 2,
                        flexShrink: 0,
                        objectFit: 'contain',
                    }}
                />
            </Box>
        </Grid>
    );

    return (
        <Box sx={{ p: 2 }}>
            <Typography
                variant="h2"
                sx={{ fontSize: 20, fontWeight: 600, lineHeight: 1.4, mb: 3 }}
            >
                Wellness Tracker
            </Typography>

            <Grid container spacing={7}>
                <ScoreCard
                    label="Wellness Score"
                    score={wellnessScore}
                    category={wellnessCategory}
                    imageSrc="images/wellnessdashboard.svg"
                    onClick={() =>
  window.open(
    `${ROUTE.WELLNESS_ADMIN_DASHBOARD}/${props.patientId}`,
    '_blank'
  )
}

                />
                <ScoreCard
                    label="i-Wise Score"
                    score={iWiseScore}
                    category={iWiseCategory}
                    imageSrc="images/mcatIScorewidget.svg"
                    onClick={() =>
                    window.open(
                        `${ROUTE.IWISE_ADMIN_DASHBOARD}/${props.patientId}`,
                        '_blank'
                    )
                    }
                />
            </Grid>
        </Box>
    );
};

export default MWiseWellnessTracker;
